// extracted by mini-css-extract-plugin
export var colorSquare = "_ud-0";
export var danger = "_ud-5";
export var lightPink = "_ud-8";
export var neutralBlue = "_ud-7";
export var neutralYellow = "_ud-6";
export var normal = "_ud-1";
export var primary = "_ud-2";
export var primaryLight = "_ud-3";
export var solidBlack = "_ud-g";
export var solidGreen = "_ud-b";
export var solidLightBlue = "_ud-d";
export var solidNavy = "_ud-c";
export var solidOrange = "_ud-f";
export var solidPink = "_ud-e";
export var solidRed = "_ud-9";
export var solidYellow = "_ud-a";
export var success = "_ud-4";